import { AVATAR_ICON_SIZE_RECORD } from '../constants/icon.mjs';
import { isAvatarPresetSize } from './cast.mjs';
import { getRelativeSizeRange } from './size.mjs';

function getAvatarIconSize(avatarSize) {
  return AVATAR_ICON_SIZE_RECORD[isAvatarPresetSize(avatarSize) ? avatarSize : getRelativeSizeRange(avatarSize)];
}

export { getAvatarIconSize };
//# sourceMappingURL=icon.mjs.map
